import StructuredData from './StructuredData';

interface ProductSchemaProps {
  name: string;
  description?: string;
  image?: string | string[];
  url?: string;
  brand?: string;
  sku?: string;
  offers?: {
    price?: string;
    priceCurrency?: string;
    availability?: string;
    url?: string;
  };
  aggregateRating?: {
    ratingValue: number;
    reviewCount: number;
  };
}

const ProductSchema: React.FC<ProductSchemaProps> = ({
  name,
  description,
  image,
  url,
  brand = 'EPEN Ltd.',
  sku,
  offers,
  aggregateRating,
}) => {
  const siteUrl = process.env.SITE_URL || 'https://vxfx.io';
  const productUrl = url || `${siteUrl}/video-plugin-framework/${name.toLowerCase().replace(/\s+/g, '-')}`;
  const productImage = image || `${siteUrl}/epenfav.webp`;

  const productSchema: any = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name,
    ...(description && { description }),
    image: Array.isArray(image) ? image : [productImage],
    url: productUrl,
    brand: {
      '@type': 'Brand',
      name: brand,
    },
    ...(sku && { sku }),
    ...(offers && {
      offers: {
        '@type': 'Offer',
        ...(offers.price && { price: offers.price }),
        ...(offers.priceCurrency && { priceCurrency: offers.priceCurrency }),
        ...(offers.availability && {
          availability: `https://schema.org/${offers.availability}`,
        }),
        ...(offers.url && { url: offers.url }),
      },
    }),
    ...(aggregateRating && {
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: aggregateRating.ratingValue,
        reviewCount: aggregateRating.reviewCount,
      },
    }),
  };

  return <StructuredData data={productSchema} />;
};

export default ProductSchema;
